<template>
    <div class="main-content">
        <el-container style="height: 680px; border: 1px solid #eee">
            <el-aside width="250px" style="background-color: rgb(238, 241, 246)">

                <el-menu >
                    <el-menu-item :index="0" style="height:45px"
                                  @contextmenu.native="handleRightClick($event,null,'root')">
                        <i class="el-icon-s-tools"></i>添加根节点菜单
                    </el-menu-item>
                    <el-submenu :index="'1-'+i" v-for="(item,i) in rootMenuList" :key="i" @contextmenu.native="handleRightClick($event,item,'')">
                        <template slot="title"><i :class="item.icons"></i>{{item.resName}}</template>
                        <el-menu-item v-for="(menuNode,j) in item.menuList" :index="item.id+'-'+j" :key="item.id" style="height:45px"
                                      @click.native.stop="getMenuList(menuNode.id)" @contextmenu.native.stop="handleRightClick($event,menuNode,'')">
                            <i :class="menuNode.icons"></i>{{menuNode.resName}}
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-aside>

            <el-container>
                <el-main>
                    <el-form class="detail-form-content"  :model="menuObj"  label-width="160px" >
                        <el-form-item label="菜单名称" class="input" prop="resName">
                            <span>{{menuObj.resName}}</span>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item label="是否为叶子节点菜单" class="input" prop="isFolder">
                            <el-radio v-model="menuObj.isFolder" label="1">是</el-radio>
                            <el-radio v-model="menuObj.isFolder" label="2">否</el-radio>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item label="菜单别名" class="input" prop="alias">
                            <span>{{menuObj.alias}}</span>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item label="同组排序" class="input" prop="sn">
                            <span>{{menuObj.sn}}</span>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item label="默认地址" class="input" prop="defaultUrl">
                            <span>{{menuObj.defaultUrl}}</span>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item label="按钮类型" class="input" prop="btnListArr">
                            <el-select v-model="menuObj.btnListArr" style="width:80%" multiple readonly>
                                <el-option v-for="(item,i) in menuBtnList" :label="item.indexName" :key="i"
                                           :value="item.codeIndex+''"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item label="图标" class="input" prop="icons">
                            <span><i :class="menuObj.icons"></i>{{menuObj.icons}}</span>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item label="是否显示" class="input" prop="isDisplayInMenu">
                                <span v-show="menuObj.isDisplayInMenu=='1'">是</span>
                                <span v-show="menuObj.isDisplayInMenu=='2'">否</span>
                        </el-form-item>
                        <el-divider></el-divider>
                    </el-form>
                </el-main>
            </el-container>
        </el-container>
        <!--右键点击菜单-->
        <el-menu
                :default-active="'1312'"
                class="el-menu-demo"
                mode="vertical"
                :collapse="isCollapse"
                v-show="menuShow"
                @close="hideMenu"
                @open="openItem"
                ref="menuRef"
                @mouseleave="menuMouseLevel"
                :style="{ left: left + 'px', top: top + 'px' }"
        >
            <el-sub-menu index="2">
                <el-menu-item index="2-1" @click="addOrg" v-show="addBtn">添加</el-menu-item>
                <el-menu-item index="2-2" @click="editOrg">编辑</el-menu-item>
                <el-menu-item index="2-3" @click="delOrg" v-show="delBtn">删除</el-menu-item>
                <el-menu-item index="2-5" @click="hideMenu">取消</el-menu-item>
            </el-sub-menu>
        </el-menu>
        <add-or-update :show="addOrUpdateFlag" :rowData="rowData" v-on:listenToChildEvent="closeDialog"></add-or-update>
    </div>
</template>
<script>
    import AddOrUpdate from "./add-or-update";
    export default {
        components: {
            AddOrUpdate,
        },
        data() {
            return {
                addBtn:true,
                delBtn:true,
                dataList: [],
                activeIndex:'0',
                menuShow:false,
                isCollapse:true,
                menuRef:null,
                left:0,
                top:0,
                addOrUpdateFlag:false,
                rowData:{},
                rootMenuList:[],
                selectOrgNode:{},
                searchForm:{
                    resName:'',
                },
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                contents:null,
                menuObj:{
                    resName:'',
                    isFolder:'',
                    alias:'',
                    sn:'',
                    defaultUrl:'',
                    btnListArr:[],
                    icons:'',
                    isDisplayInMenu:'',
                },
                menuBtnList:[],
            }
        },
        created(){
            this.initMenuList();
            this.getMenuList();
            this.initBtnList();
            //this.contentStyleChange();
        },
        methods:{
            handleRightClick(e,node,type) {
                if (type!='root'){
                    this.selectOrgNode = node;
                    if(node.parentId!='0'){
                        this.addBtn = false;
                    }else{
                        this.addBtn = true;
                    }
                }
                // 阻止默认的右键菜单显示
                this.delBtn = false;
                e.preventDefault();
                this.menuShow = true;
                this.left = e.clientX+1;
                this.top = e.clientY+1;
            },

            hideMenu(){
                this.menuShow = false;
                this.selectOrgNode = {};
            },
            openItem(index, indexPath){
                console.log(index, indexPath)
            },
            menuMouseLevel(e){
                this.menuShow = false;
                this.left = 0;
                this.top = 0;
            },
            addOrg(){
                this.menuShow = false;
                this.addOrUpdateFlag = true;
                this.selectOrgNode.type = 'add';
                this.rowData = this.selectOrgNode;
            },
            editOrg(){
                this.menuShow = false;
                this.addOrUpdateFlag = true;
                this.selectOrgNode.type = 'edit';
                this.rowData = this.selectOrgNode;
            },
            delOrg(){
                this.menuShow = false;
                var ids = [this.selectOrgNode.orgId];

                this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "menu/delete",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.initMenuList();
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
            closeDialog(){
                this.addOrUpdateFlag = false;
                this.initMenuList();
                this.getMenuList();
                //this.getDataList();
            },
            initMenuList(){
                this.$http({
                    url: "menu/getTreeMenuList",
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.rootMenuList = data.rootMenuList;
                        console.log(data.rootMenuList);
                    }
                });
            },
            getMenuList(menuId){
                this.$http({
                    url: "menu/info/"+menuId,
                    method: "get",
                }).then(({data}) => {
                    if (data.data!=null){
                        this.menuObj = data.data;
                        this.menuObj.btnListArr = this.menuObj.btnList.split(",");
                    }
                });
            },
            formatDate(dateStr){
                let date = new Date(dateStr);
                return date.toLocaleString();
            },
            searchOrgList(e,node){
                e.preventDefault();
                this.getMenuList(node.orgId);
            },
            //每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getMenuList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getMenuList();
            },
            initBtnList(){
                let params = {
                    page: this.pageIndex,
                    limit: this.pageSize,
                    sort: 'id',
                }
                //本表的
                params['dicCode'] = "menu_types"//编码名字
                params['dicName'] = "按钮类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.menuBtnList = data.data.list;
                    }
                });
            }
        }
            
    };
</script>
<style>
    .el-header {
        background-color: var(--publicMainColor);
        color: #fff;
        line-height: 60px;
    }

    .el-aside {
        color: #303133;
    }
</style>

<style scoped>
    .main-content {
        background: #fff;
        border-radius: 6px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .el-menu-demo {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
        width: 120px;
    }
</style>